var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmptySearchList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 200,
  height: 201,
  fill: "none",
  viewBox: "0 0 200 201"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 108,
  height: 136,
  x: 46,
  y: 32.5,
  fill: "#E6EBF0",
  rx: 16
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 10,
  x: 64,
  y: 123.167,
  fill: "#fff",
  rx: 4
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 10,
  x: 64,
  y: 105.033,
  fill: "#fff",
  rx: 4
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 10,
  x: 64,
  y: 86.9,
  fill: "#9AA7B5",
  rx: 4
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 10,
  x: 64,
  y: 68.767,
  fill: "#9AA7B5",
  rx: 4
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 10,
  x: 64,
  y: 50.633,
  fill: "#9AA7B5",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#9AA7B5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "m136 95.967-6.525-6.574M121 73.3c4.142 0 7.5 3.383 7.5 7.556m4.5 0c0 6.676-5.373 12.089-12 12.089s-12-5.413-12-12.09c0-6.676 5.373-12.088 12-12.088s12 5.412 12 12.089Z"
})));
export { SvgEmptySearchList as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgImRhdGE6aW1hZ2Uvc3ZnK3htbDtiYXNlNjQsUEhOMlp5QjNhV1IwYUQwaU1qQXdJaUJvWldsbmFIUTlJakl3TVNJZ2RtbGxkMEp2ZUQwaU1DQXdJREl3TUNBeU1ERWlJR1pwYkd3OUltNXZibVVpSUhodGJHNXpQU0pvZEhSd09pOHZkM2QzTG5jekxtOXlaeTh5TURBd0wzTjJaeUkrQ2p4eVpXTjBJSGc5SWpRMklpQjVQU0l6TWk0MUlpQjNhV1IwYUQwaU1UQTRJaUJvWldsbmFIUTlJakV6TmlJZ2NuZzlJakUySWlCbWFXeHNQU0lqUlRaRlFrWXdJaTgrQ2p4eVpXTjBJSGc5SWpZMElpQjVQU0l4TWpNdU1UWTNJaUIzYVdSMGFEMGlOeklpSUdobGFXZG9kRDBpTVRBaUlISjRQU0kwSWlCbWFXeHNQU0ozYUdsMFpTSXZQZ284Y21WamRDQjRQU0kyTkNJZ2VUMGlNVEExTGpBek15SWdkMmxrZEdnOUlqY3lJaUJvWldsbmFIUTlJakV3SWlCeWVEMGlOQ0lnWm1sc2JEMGlkMmhwZEdVaUx6NEtQSEpsWTNRZ2VEMGlOalFpSUhrOUlqZzJMamtpSUhkcFpIUm9QU0l6TmlJZ2FHVnBaMmgwUFNJeE1DSWdjbmc5SWpRaUlHWnBiR3c5SWlNNVFVRTNRalVpTHo0S1BISmxZM1FnZUQwaU5qUWlJSGs5SWpZNExqYzJOamNpSUhkcFpIUm9QU0l6TmlJZ2FHVnBaMmgwUFNJeE1DSWdjbmc5SWpRaUlHWnBiR3c5SWlNNVFVRTNRalVpTHo0S1BISmxZM1FnZUQwaU5qUWlJSGs5SWpVd0xqWXpNek1pSUhkcFpIUm9QU0kzTWlJZ2FHVnBaMmgwUFNJeE1DSWdjbmc5SWpRaUlHWnBiR3c5SWlNNVFVRTNRalVpTHo0S1BIQmhkR2dnWkQwaVRURXpOaUE1TlM0NU5qWTNUREV5T1M0ME56VWdPRGt1TXprek0wMHhNakVnTnpNdU0wTXhNalV1TVRReUlEY3pMak1nTVRJNExqVWdOell1TmpneU55QXhNamd1TlNBNE1DNDROVFUyVFRFek15QTRNQzQ0TlRVMlF6RXpNeUE0Tnk0MU16SXhJREV5Tnk0Mk1qY2dPVEl1T1RRME5TQXhNakVnT1RJdU9UUTBOVU14TVRRdU16Y3pJRGt5TGprME5EVWdNVEE1SURnM0xqVXpNakVnTVRBNUlEZ3dMamcxTlRaRE1UQTVJRGMwTGpFM09URWdNVEUwTGpNM015QTJPQzQzTmpZM0lERXlNU0EyT0M0M05qWTNRekV5Tnk0Mk1qY2dOamd1TnpZMk55QXhNek1nTnpRdU1UYzVNU0F4TXpNZ09EQXVPRFUxTmxvaUlITjBjbTlyWlQwaUl6bEJRVGRDTlNJZ2MzUnliMnRsTFhkcFpIUm9QU0l6SWlCemRISnZhMlV0YkdsdVpXTmhjRDBpY205MWJtUWlJSE4wY205clpTMXNhVzVsYW05cGJqMGljbTkxYm1RaUx6NEtQQzl6ZG1jK0NnPT0i";